import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Form from './Form';
import TableData from './TableData';

@observer
export default class Content extends Component{
    render(){
    	 const { store:{isHide}} = this.props;
        return (
            <div className='content'>
               {!isHide &&   <Form ecId={`${this && this.props && this.props.ecId || ''}_Form@0pwmop`} store={this.props.store} />}
                <TableData ecId={`${this && this.props && this.props.ecId || ''}_TableData@nk0k0h`} store={this.props.store} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/financeV2/Content.js